import React, { useState } from 'react';
import {
    Card, Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TextField, Paper, InputAdornment,
    Checkbox, FormControlLabel, Grid, Button, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";

const planName = ["SMS/Basic"];
const frequencies = ["1 Month"];
const planColors = ["#e0f7fa", "#b3e5fc", "#c8e6c9"];

const Communication = () => {
    const [isOfferApplicable, setIsOfferApplicable] = useState(false);

    const [tableData, setTableData] = useState(
        planName.map(() =>
            frequencies.map(() => ({
                discount: '',
                price: '',
                offerPrice: '',
                offerPercentage: ''
            }))
        )
    );

    const handleChange = (planIndex, freqIndex, field, value) => {
        const updatedData = tableData.map((plan, pIdx) =>
            plan.map((freq, fIdx) => {
                if (pIdx === planIndex && fIdx === freqIndex) {
                    return { ...freq, [field]: value };
                }
                return freq;
            })
        );
        setTableData(updatedData);
    };

    const handleSubmit = () => {
        console.log('Form submitted with data:', tableData);
        alert('Form submitted successfully!');
    };

    return (
        <Box sx={{ p: 2 }}>
            <Card elevation={3} sx={{ p: 3, mb: 2 }}>
                <Typography sx={{ mb: 2, color: '#a00', fontSize: '20px', fontWeight: '600' }}>
                    Communication Channel
                </Typography>

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid item xs={12} sm={12} md={3}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isOfferApplicable}
                                    onChange={() => setIsOfferApplicable((prev) => !prev)}
                                />
                            }
                            label="Offer Applicable"
                            sx={{ marginBottom: 2 }}
                        />
                    </Grid>

                    {/* Hide Communication Type when Offer Applicable is checked */}
                    {!isOfferApplicable && (
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth sx={{ height: "56px" }}>
                                <InputLabel>Communication Type</InputLabel>
                                <Select name="communicationType">
                                    <MenuItem value="sms">SMS</MenuItem>
                                    <MenuItem value="email">Email</MenuItem>
                                    <MenuItem value="whatsapp">WhatsApp</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    )}

                    {isOfferApplicable && (
                        <>
                            <Grid item xs={12} sm={12} md={3}>
                                <TextField
                                    type="date"
                                    label="Offer Valid From"
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ width: "100%" }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3}>
                                <TextField
                                    type="date"
                                    label="Offer Valid To"
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ width: "100%" }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3}>
                                <TextField
                                    label="Offer Text"
                                    sx={{ width: "100%" }}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Plan</TableCell>
                                <TableCell align="center">Frequency</TableCell>
                                <TableCell align="center">Frequency Discount (%)</TableCell>
                                <TableCell align="center">Price (INR)</TableCell>
                                {isOfferApplicable && (
                                    <>
                                        <TableCell align="center">Offer Price (INR)</TableCell>
                                        <TableCell align="center">Offer Percentage (%)</TableCell>
                                    </>
                                )}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {planName.map((plan, planIndex) =>
                                frequencies.map((frequency, freqIndex) => (
                                    <TableRow key={`${planIndex}-${freqIndex}`}>
                                        {freqIndex === 0 && (
                                            <TableCell
                                                align="center"
                                                rowSpan={frequencies.length}
                                                sx={{
                                                    backgroundColor: planColors[planIndex % planColors.length],
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {plan}
                                            </TableCell>
                                        )}
                                        <TableCell align="center">{frequency}</TableCell>

                                        <TableCell align="center">
                                            <TextField
                                                variant="outlined"
                                                value={tableData[planIndex][freqIndex].discount}
                                                onChange={(e) => handleChange(planIndex, freqIndex, 'discount', e.target.value)}
                                                InputProps={{
                                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                }}
                                                sx={{ width: "100%", textAlign: "center" }}
                                            />
                                        </TableCell>

                                        <TableCell align="center">
                                            <TextField
                                                variant="outlined"
                                                value={tableData[planIndex][freqIndex].price}
                                                onChange={(e) => handleChange(planIndex, freqIndex, 'price', e.target.value)}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                                }}
                                                sx={{ width: "100%", textAlign: "center" }}
                                            />
                                        </TableCell>

                                        {isOfferApplicable && (
                                            <>
                                                <TableCell align="center">
                                                    <TextField
                                                        variant="outlined"
                                                        value={tableData[planIndex][freqIndex].offerPrice}
                                                        onChange={(e) => handleChange(planIndex, freqIndex, 'offerPrice', e.target.value)}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                                        }}
                                                        sx={{ width: "100%", textAlign: "center" }}
                                                    />
                                                </TableCell>

                                                <TableCell align="center">
                                                    <TextField
                                                        variant="outlined"
                                                        value={tableData[planIndex][freqIndex].offerPercentage}
                                                        onChange={(e) => handleChange(planIndex, freqIndex, 'offerPercentage', e.target.value)}
                                                        InputProps={{
                                                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                        }}
                                                        sx={{ width: "100%", textAlign: "center" }}
                                                    />
                                                </TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>


                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        sx={{
                            height: "100%",
                            background:
                                "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
                            color: "#fff",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                            textTransform: "uppercase",
                            fontWeight: "bold",
                            "&:hover": {
                                background:
                                    "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
                                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
                            },
                        }}
                    >
                        Submit
                    </Button>
                </Box>
            </Card>
        </Box>
    );
};

export default Communication;
